const mainConfig = JSON.parse(localStorage.getItem("mainConfig"));
const scheme = ""// process?.env?.REACT_APP_SCHEME; 
const gatewayHost = mainConfig?.apiUrl;//
const provider = mainConfig?.provider;// process?.env?.REACT_APP_PROVIDER;

console.log(gatewayHost)

const Config = { 
    "provider":provider != null ? provider : "assets",
    "endpoint":gatewayHost,
    "spvDebug":true,
    "dateFormat":"DD-MMM-YY",
    "dateFormatValidate":function(value){return /^(([0-9])|([0-2][0-9])|([3][0-1]))\-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-\d{2}$/.test(value);},
    "dateFormatStandard":"YYYY-MM-DD",
    "dateFormatInput":"dd-MMM-yy",
    "dateFormatInputPost":"DD-MMM-YY",
    "timeFormat":"hh:mm a",
    "dateTimeFormat":"DD-MMM-YY hh:mm a",
    "roundAmount":localStorage.getItem("prefRoundAmt") || 0,
    "roundFraction":localStorage.getItem("prefRoundFraction") || 2,
    "amountDivision":localStorage.getItem("amountDivision") || 1,
    "amountSymbol": localStorage.getItem("amountSymbol") || "",
    "amountTooltip":true,
    "amountComma":true,
    "minusInBracket":false,
    "defaultPageSize": 10,
    "pageRangeDisplayed": 10,
    "tablePageSize":10,
    "s3Cdn":"https://pro-cdn.investera.com/investor-portal-files/",
    "system":{},
    "jwt":localStorage.getItem("jwt"),
    api: url => {
       return gatewayHost + url;
      // return gatewayHost+url;
    },
    apiUrl:gatewayHost,
    dateTypes:[{
        value: "TRADEDATE",
        name:"Trade Date"
     },{
        value: "VALUEDATE",
        name:"Value Date"
     },],
     fileIcons:{
      pdf:"fa fa-file-pdf-o",
      jpeg:"fa fa-picture-o",
      png:"fa fa-picture-o",
      xls:"fa fa-file-excel-o",
      csv:"fas fa-file-csv",
      doc:"fa fa-file"

     },
     pageNames:{
      reports:"REPORTS",
      documents:"DOCUMENTS",
      forms:"FORMS",
      vdr:"VDR"
     }
}

export default Config;
